module.exports = __webpack_public_path__ + "static/media/Montana2927.7e7ea389.jpg";